module.exports = __webpack_public_path__ + "img/natura_logo.c2355570.webp";